import { render } from "./applicantList.vue?vue&type=template&id=00738464&scoped=true"
import script from "./applicantList.vue?vue&type=script&lang=js"
export * from "./applicantList.vue?vue&type=script&lang=js"

import "./applicantList.vue?vue&type=style&index=0&id=00738464&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00738464"]])

export default __exports__